import { Link } from "react-router-dom";
import { faqs } from "@/mocks/faqs";
import FaqList from "@/components/feature/FaqList";

export default function FaqSection() {
  return (
    <section id="faq" className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 uppercase">
            <span className="w-6 h-px bg-primary-500"></span>
            FAQ
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-4 text-sm md:text-base leading-7 text-foreground-600">
            关于收藏、书签、标记与关注，这里整理了大家最常问的几个问题。还有疑问？可以去完整问答页看看。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            查看全部问题
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="lg:col-span-8">
          <FaqList items={faqs.slice(0, 5)} />
        </div>
      </div>
    </section>
  );
}